import React from 'react'
import _ from 'lodash'

const BkFlowSideBarPolicyEntries = props => {
  const {
    roomPolicies
  } = props

  let renderRoomPolicies = []

  // construct room policy DOM elements under payment sidebar component
  if (!_.isEmpty(roomPolicies)) {
    for (const policyKey in roomPolicies) {
      const currentPolicy = roomPolicies[policyKey]

      if (currentPolicy.text) {
        renderRoomPolicies.push(<p key={currentPolicy.name}>{currentPolicy.text}</p>)
      }
    }
  }

  return renderRoomPolicies
}

export default BkFlowSideBarPolicyEntries



// WEBPACK FOOTER //
// ./src/components/payment/sidebar/policies/elements/BkFlowSidebarPolicyEntries.js